<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-excel-import :key="ver" :entity="entity" :task="import" stream-address="aut/process-group/stream-create" @close="reset" @cancel="reset" />
</template>
<script>
	import { ProcessGroup } from '@/modules/aut/data/process-group/create'
	import { ProcessGroupService } from '@/modules/aut/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed:
		{
			entity()
			{
				return ProcessGroup;
			},

			service()
			{
				return new ProcessGroupService();
			}
		},
		methods:
		{
			async import(payload)
			{
				return await this.service.create(payload, {HSR:false, HER:false});
			},

			reset()
			{
				this.ver = this.ver + 1;
			}
		}
	}
</script>